import { UserStatus, UserRole, USER_ROLE_LABEL, userRoleGroups } from '../../interfaces/user'
import { FilterFieldType, IFilter } from './types'

export const USER_MANAGEMENT_FILTERS_CONFIG = [
  {
    field: 'firstName',
    type: FilterFieldType.Text,
    dbField: 'first_name',
    isSortable: true,
    title: 'First Name',
  },
  {
    field: 'lastName',
    type: FilterFieldType.Text,
    dbField: 'last_name',
    isSortable: true,
    title: 'Last Name',
  },
  {
    field: 'email',
    dbField: 'email',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Email',
  },
  {
    field: 'phone',
    dbField: 'phone',
    alias: 'users',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Phone',
  },
  {
    field: 'status',
    dbField: 'status',
    type: FilterFieldType.List,
    title: 'Status',
    isSortable: true,
    options: [
      {
        value: UserStatus.New,
        label: 'Invitation Sent',
      },
      {
        value: UserStatus.Active,
        label: 'Active',
      },
    ],
  },
] as const satisfies IFilter[]

export const USER_MANAGEMENT_CLIENT_FILTERS_CONFIG = [
  {
    field: 'isAuthorizedSignature',
    dbField: 'is_authorized_signature',
    alias: 'clientInfoUsers',
    type: FilterFieldType.Boolean,
    title: 'Authorized Signature',
    options: [
      {
        value: 'true',
        label: 'Authorized',
      },
      {
        value: 'false',
        label: 'Not authorized',
      },
    ],
  },
  {
    field: 'isReportingReminderReceiver',
    dbField: 'is_reporting_reminder_receiver',
    alias: 'clientInfoUsers',
    type: FilterFieldType.Boolean,
    title: 'Reporting Reminders',
    options: [
      {
        value: 'true',
        label: 'Reporting Reminders receiver',
      },
      {
        value: 'false',
        label: 'Not Reporting Reminders receiver',
      },
    ],
  },
  {
    field: 'isViewer',
    dbField: 'is_viewer',
    alias: 'clientInfoUsers',
    type: FilterFieldType.Boolean,
    title: 'BBC Viewer',
    options: [
      {
        value: 'true',
        label: 'BBC viewer',
      },
      {
        value: 'false',
        label: 'Not BBC viewer',
      },
    ],
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
  },
] as const satisfies IFilter[]

export const USER_MANAGEMENT_PARTICIPANT_FILTERS_CONFIG = [
  {
    field: 'companies',
    alias: 'clientInfoUsers',
    type: FilterFieldType.Text,
    title: 'Clients',
    isSortable: false,
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
  },
] as const satisfies IFilter[]

export const USERS_LIST_FILTERS_CONFIG = [
  {
    field: 'firstName',
    dbField: 'first_name',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'First Name',
    title: 'First name',
  },
  {
    field: 'lastName',
    dbField: 'last_name',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'Last Name',
    title: 'Last name',
  },
  {
    field: 'email',
    type: FilterFieldType.Text,
    isSortable: true,
    placeholder: 'Email',
    title: 'Email',
  },
  {
    field: 'role',
    type: FilterFieldType.List,
    options: [
      {
        value: 'all',
        label: 'All',
      },
      {
        value: UserRole.ADMIN,
        label: USER_ROLE_LABEL[UserRole.ADMIN],
      },
      {
        value: UserRole.PORTFOLIO_ADMIN,
        label: USER_ROLE_LABEL[UserRole.PORTFOLIO_ADMIN],
      },
      {
        value: UserRole.PORTFOLIO_USER,
        label: USER_ROLE_LABEL[UserRole.PORTFOLIO_USER],
      },
      {
        value: UserRole.BDO,
        label: USER_ROLE_LABEL[UserRole.BDO],
      },
      {
        value: UserRole.UW_USER,
        label: USER_ROLE_LABEL[UserRole.UW_USER],
      },
      {
        value: UserRole.TASKS_AND_MESSAGING,
        label: USER_ROLE_LABEL[UserRole.TASKS_AND_MESSAGING],
      },
    ],
    title: 'Role',
  },
  {
    type: FilterFieldType.List,
    field: 'client',
    isCustom: true,
    options: [
      {
        value: 'all',
        label: 'All',
      },
      {
        value: 'active',
        label: 'New',
      },
      {
        value: 'sent',
        label: 'Active',
      },
    ],
    title: 'Clients',
  },
  {
    field: 'status',
    type: FilterFieldType.List,
    isSortable: true,
    options: [
      {
        value: 'all',
        label: 'All',
      },
      {
        value: 'active',
        label: 'New',
      },
      {
        value: 'sent',
        label: 'Active',
      },
    ],
    title: 'Status',
  },
  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    fields: [
      {
        field: 'roles',
        type: FilterFieldType.List,
      },
    ],
    quickFilters: [
      {
        title: 'Internal',
        filters: {
          // Display-only, so tasks-and-messaging users count as staff here without
          // joining INTERNAL, the permission group.
          roles: userRoleGroups.MESSAGING,
        },
      },
      {
        title: 'Client',
        filters: {
          roles: userRoleGroups.CLIENTS,
        },
      },
    ],
  },
] as const satisfies IFilter[]

export const RELATIONSHIP_MANAGERS_FILTERS_CONFIG = [
  {
    field: 'firstName',
    type: FilterFieldType.Text,
    dbField: 'first_name',
    isSortable: true,
    title: 'First Name',
  },
  {
    field: 'lastName',
    type: FilterFieldType.Text,
    dbField: 'last_name',
    isSortable: true,
    title: 'Last Name',
  },
  {
    field: 'email',
    dbField: 'email',
    type: FilterFieldType.Text,
    isSortable: true,
    title: 'Email',
  },
  {
    field: 'is_notified',
    dbField: 'is_notified',
    type: FilterFieldType.List,
    title: 'Status',
    isSortable: true,
    options: [
      {
        value: 'Notification Sent',
        label: 'Notification Sent',
      },
      {
        value: 'Send Notification',
        label: 'Send Notification',
      },
    ],
  },

  {
    field: 'action',
    type: FilterFieldType.Empty,
    title: 'Action',
    align: 'right',
  },
] as const satisfies IFilter[]
